module.exports = __webpack_public_path__ + "img/Puskás_Aréna_01.5141074f.jpg";